import { getS3SessionSnapshot } from '@/services/s3Session'

// Build a Mapbox transformRequest callback (ADR-0016).
//
// Tiles are now served same-origin through CloudFront at /s3/lyr/... — the
// browser attaches the CloudFront signed cookies automatically, so there is no
// per-tile signing to do. Two concerns remain (both sync):
//   1. /s3/lyr/... → gate on the cookie session so we don't fire tile requests
//      during the org-switch gap before cookies are set (they'd 403 at the
//      edge). Once a session exists, pass through untouched (cookies ride the
//      same-origin request).
//   2. /tulum/tiles/... and /tulum/tasking/... → attach the Bearer header;
//      tulum refuses tile requests without credentials.
// Anything else passes through.

export function makeTransformRequest() {
  return (url, _resourceType) => {
    // CloudFront-served tiles
    if (url.includes('/s3/lyr/')) {
      if (!getS3SessionSnapshot()) {
        // Mapbox has no "skip" return; data:, is a valid no-op URI that
        // resolves instantly without hitting the edge (avoids a 403 storm).
        return { url: 'data:,' }
      }
      return undefined
    }

    // Tulum proxy (planet orders, planetscope passthrough, tasking captures)
    if (url.includes('/tulum/tiles/') || url.includes('/tulum/tasking/')) {
      const accessToken = localStorage.getItem('accessToken')
      if (accessToken) {
        return { url, headers: { Authorization: `Bearer ${accessToken}` } }
      }
    }

    return undefined
  }
}
